import React, { useMemo } from "react";
import styled, { withTheme } from "styled-components";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import Paper from "../../../components/ui-library/Paper/Paper";
import SmartAuditTrail from "../../../components/smart/AuditTrail/AuditTrail";
import { appStudy } from "../../../config";

const AuditTrail = (props) => {
  const { route, studies } = props;

  const studyCode = useMemo(
    () =>
      studies?.find(
        (o) => o?.studyId?.toLowerCase() === route?.study?.toLowerCase()
      )?.code ?? "",
    [studies, route]
  );

  return (
    <>
      <SmartPageHeader
        studyId={route.study}
        title={studyCode || appStudy.toUpperCase()}
      />
      <Paper header="Audit Trail">
        <SmartAuditTrail />
      </Paper>
    </>
  );
};

export default connect(mapStateToPropsLogin, null)(withTheme(AuditTrail));
